import { observer } from 'mobx-react';
import { UseCaseExplorePayload } from '../../../../../../../DiscoveryStore/Types';
import RegistrationType from './RegistrationType';
import Source from './Source';

interface Props {
  useCaseExplorePayload: UseCaseExplorePayload;
}

function Badges({ useCaseExplorePayload }: Props) {
  return (
    <div className="flex flex-row gap-2">
      <Source source={useCaseExplorePayload.source} />
      <RegistrationType registrationType={useCaseExplorePayload.registrationType} />
    </div>
  );
}

export default observer(Badges);
